module.exports = __webpack_public_path__ + "static/0056-ddb609c21e5a917ccd5b97738c1fd49b.png";